import axios from "axios"
import { APIURL } from "../Constantes"
import { getCabecera } from "../utils/getCabecera"
import { getError } from "../utils/errors"

const urlMetric = "Metric"

//* Obtener metricas
//* GET /api/Metric/Income/{FecIni}/{FecFin}
export const getMetricaEntradas = async ({ FecIni, FecFin }) => {
    return axios.get(`${APIURL}/${urlMetric}/Income/${FecIni}/${FecFin}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data
        }).catch((Error) => {
            //return Error.response.data;
            return {}
        })
}
//* Obtener metricas metodos de pago
//* GET /api/Metric/Income/PaymentPlan/{FecIni}/{FecFin}
export const getMetricaEntrasMetodoPago = async ({ FecIni, FecFin }) => {
    return axios.get(`${APIURL}/${urlMetric}/Income/PaymentPlan/${FecIni}/${FecFin}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return {};
        })
}
//* Obtener egresos por pesos y dolares
//* GET /api/Metric/Expenses/{FecIni}/{FecFin}
export const getMetricaSalidas = async ({ FecIni, FecFin }) => {
    return axios.get(`${APIURL}/${urlMetric}/Expenses/${FecIni}/${FecFin}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return {};
        })
}
//* Obtener report de movimientos 
//* GET /api/Metric/Income/Report/{FecIni}/{FecFin}
export const getReporteIngresos = async ({ FecIni, FecFin }) => {
    return axios.get(`${APIURL}/${urlMetric}/Income/Report/${FecIni}/${FecFin}`, {
        headers: getCabecera(),
        responseType: 'blob'
    }).then((Response) => {
        return Response;
    }).catch((Error) => {
        //return getError(Error);
        return []
    })
}
//* Obtener reporte de egresos dolares
//* GET /api/Metric/Expenses/Report/USD/{FecIni}/{FecFin}
export const getReporteEgresosDolares = async ({ FecIni, FecFin }) => {
    return axios.get(`${APIURL}/${urlMetric}/Expenses/Report/USD/${FecIni}/${FecFin}`, {
        headers: getCabecera(),
        responseType: 'blob'
    }).then((Response) => {
        return Response;
    }).catch((Error) => {
        //return getError(Error);
        return []
    })
}
//* Obtener reporte de egresos pesos
//* GET /api/Metric/Expenses/Report/MXN/{FecIni}/{FecFin} 
export const getReporteEgresosPesos = async ({ FecIni, FecFin }) => {
    return axios.get(`${APIURL}/${urlMetric}/Expenses/Report/MXN/${FecIni}/${FecFin}`, {
        headers: getCabecera(),
        responseType: 'blob'
    }).then((Response) => {
        return Response;
    }).catch((Error) => {
        //return getError(Error);
        return []
    })
}
//* Obtener reporte de ingresos por mes
//* GET /api/Metric/Income/Monthly/{FecIni}/{FecFin}
export const getMetricaEntrasMensual = async ({ FecIni, FecFin }) => {
    return axios.get(`${APIURL}/${urlMetric}/Income/Monthly/${FecIni}/${FecFin}`,
    {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        //return Error.response.data;
        return []
    })
}
//* Obtener reporte de egresos por mes 
//* GET Metric/Expenses/Monthly/{FecIni}/{FecFin}
export const getMetricaEgresosMensual = async ({ FecIni, FecFin }) => {
    return axios.get(`${APIURL}/${urlMetric}/Expenses/Monthly/${FecIni}/${FecFin}`,
    {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        //return Error.response.data;
        return []
    })
}